// @变量配置在.eslintrc.js
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/js/rem.js'
import '@/assets/js/directive.js' // 自定义指令
import '@/assets/js/veeValidate.js'
import * as fundebug from "fundebug-javascript"
import fundebugVue from "fundebug-vue"
import { Dialog, DatetimePicker, Popup, PasswordInput, NumberKeyboard, ActionSheet } from 'vant'
import commonDialog from "@/components/commonDialog"
import thirdPage from "@/components/thirdPage"
import filters from '@/assets/js/filters.js'
import myaxios from "@/assets/js/request"
import reportApi from "@/assets/js/report"
// import reportApi from "@/assets/js/reportTmp"
import defaultImg from './directive/defaultImg';

// 全局 mixin：为所有组件实例提供 toJSON，防止 fundebug-vue / vConsole 等库
// 序列化 Vue 实例时触发 "Property or method toJSON is not defined" 警告
Vue.mixin({
  methods: {
    toJSON() {
      return { $name: this.$options.name || 'Anonymous' }
    }
  }
})

fundebug.init({
  apikey: "5f0d3c6de213055c1afc1550c9ce0acbb1dd431050369faa43d99f76b3df70dc",
  appversion: "1.3.6"
})
fundebugVue(fundebug, Vue)

Vue.config.productionTip = false

// 捕获未知promise reject异常，通常来自于第三库的报错
window.onunhandledrejection = function (e) {
  console.log(e)
  e.preventDefault()
}
Vue.use(Dialog)
Vue.use(DatetimePicker)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(ActionSheet)
Vue.use(Popup)
Vue.use(defaultImg);

// 全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
// 全局公共组件
Vue.component('commonDialog', commonDialog)
Vue.component('thirdPage', thirdPage)
// 全局axios
Vue.prototype.myaxios = myaxios
// 埋点
Vue.prototype.reportApi = reportApi

// 路由守卫
router.beforeEach((to, from, next) => {
  clearInterval(window.timer)
  window.timer = null
  next()
})

new Vue({
  router,
  render: h => h(App),
  // 添加mounted，不然不会执行预编译
  async mounted () {
    if (process.env.NODE_ENV === 'ssr') {
      try {
        // 等待页面关键数据加载（示例：调用 Vuex 异步 action）
        // await this.$store.dispatch('fetchPageData'); // 假设这是加载数据的异步方法

        this.$nextTick(() => {
          document.dispatchEvent(new Event('render-event'))
        });
      } catch (error) {
        console.error('数据加载失败，仍触发渲染:', error);
        // 即使数据加载失败，也触发渲染避免构建卡住
        document.dispatchEvent(new Event('render-event'));
      }
    }
  }
}).$mount('#app')